// app/javascript/controllers/no_spaces_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  preventSpaces(event) {
    event.target.value = event.target.value.replace(/\s/g, "");
  }
}
